var _use, _symbol;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64.734 57.734",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 1.367,
    y: 1.367
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.918 27.048c0-3.166 2.549-5.715 5.715-5.715s5.715 2.549 5.715 5.715-2.549 5.715-5.715 5.715-5.715-2.549-5.715-5.715z",
    stroke: "none",
    fill: "#00d8ff"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#00d8ff",
    fill: "none",
    strokeWidth: 2.734
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.633 15.428c7.673 0 14.801 1.101 20.176 2.951 6.476 2.229 10.457 5.609 10.457 8.669 0 3.19-4.22 6.779-11.174 9.083-5.257 1.743-12.176 2.651-19.46 2.651-7.468 0-14.54-.853-19.856-2.67C4.05 33.812 0 30.176 0 27.048c0-3.035 3.802-6.388 10.186-8.614 5.395-1.88 12.699-3.006 20.447-3.006z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.517 21.272C24.351 14.625 28.865 9 33.153 5.268 38.32.772 43.236-.989 45.887.54c2.762 1.593 3.764 7.042 2.286 14.217-1.117 5.425-3.786 11.872-7.425 18.182-3.731 6.469-8.003 12.169-12.232 15.866-5.352 4.679-10.526 6.372-13.236 4.809-2.629-1.515-3.635-6.484-2.373-13.127 1.066-5.613 3.74-12.502 7.61-19.214z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.528 32.955c-3.844-6.639-6.462-13.361-7.553-18.94C11.66 7.294 12.59 2.156 15.238.622c2.76-1.598 7.981.256 13.458 5.12 4.142 3.677 8.395 9.209 12.044 15.513 3.742 6.463 6.546 13.01 7.637 18.521 1.38 6.973.262 12.301-2.444 13.869-2.627 1.521-7.433-.089-12.559-4.5-4.33-3.725-8.963-9.484-12.846-16.19z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactIcon);
export default __webpack_public_path__ + "static/media/react-icon.2ff1c8e6d5c24349260366292539ad49.svg";
export { ForwardRef as ReactComponent };